import React from "react";
import {
  type Insets,
  Pressable,
  type PressableProps,
  type StyleProp,
  type ViewStyle,
} from "react-native";

import { spacing } from "../styles";

type Props = PressableProps & {
  activeOpacity?: number;
  style?: StyleProp<ViewStyle>;
};

const hitSlops: Insets = {
  bottom: spacing.unit,
  left: spacing.unit,
  right: spacing.unit,
  top: spacing.unit,
};

const Touchable = ({ activeOpacity, onPress, children, style, disabled, ...rest }: Props) => (
  <Pressable
    {...rest}
    disabled={disabled || !onPress}
    hitSlop={hitSlops}
    onPress={onPress}
    style={({ pressed }) => [style, (pressed || disabled) && { opacity: activeOpacity || 0.75 }]}
  >
    {children}
  </Pressable>
);

export default React.memo(Touchable);
